import React from 'react';
import { FormattedMessage } from 'react-intl';

import { trackAction } from 'app/shared/utils/tracking';

import { getNetworkTrackingPropertyGroup } from './utils';

export const track = (props, eventName) => {
  const { network } = props;
  const trackingNetwork = getNetworkTrackingPropertyGroup(network);

  return trackAction(eventName, { category: 'dealer_portal' }, trackingNetwork);
};

export const menuItems = (pathName = '', props = {}) => {
  return [
    {
      href: '/dealer/dashboard',
      isActive: pathName.includes('/dealer/dashboard'),
      label: (
        <FormattedMessage
          id="dealer.menuItems.myDashboard"
          defaultMessage="Übersicht"
        />
      ),
      onClick: () => track(props, 'my_dashboard_click'),
    },
    {
      href: '/dealer/leads',
      isActive: pathName.includes('/dealer/lead'),
      label: (
        <FormattedMessage
          id="dealer.menuItems.myLeads"
          defaultMessage="Meine Leads"
        />
      ),
      onClick: () => track(props, 'my_leads_click'),
    },
    {
      href: '/dealer/listings',
      isActive: pathName === '/dealer/listings',
      label: (
        <FormattedMessage
          id="dealer.menuItems.myListings"
          defaultMessage="Meine Inserate"
        />
      ),
      onClick: () => track(props, 'my_listings_click'),
    },
    {
      href: '/dealer/service',
      isActive: pathName.includes('/dealer/service'),
      label: (
        <FormattedMessage
          id="dealer.menuItems.service"
          defaultMessage="Service"
        />
      ),
      onClick: () => track(props, 'service_click'),
    },
    {
      href: '/dealer/account',
      isActive:
        pathName.includes('/dealer/account') ||
        pathName.includes('/dealer/payment-method'),
      label: (
        <FormattedMessage
          id="dealer.menuItems.account"
          defaultMessage="Mein Autohaus"
        />
      ),
      onClick: () => track(props, 'my_account_click'),
    },
  ];
};
